import { Moment } from 'moment';

export interface IDatePeriod {
	begin: Moment;
	end: Moment;
}
